<template>
    <div v-show="visible">
        <el-dialog title="新增" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="350px">    
            <el-form ref="form" :model="form" :rules="rules"  v-loading="loading" label-width="80px">
                    <el-form-item prop="name" label="姓名">
                        <el-input v-model="form.name" maxlength="80" style="width:195px;"></el-input>
                    </el-form-item>
                    
                    <el-form-item prop="identityCard" label="身份证">
                        <el-input v-model="form.identityCard" maxlength="18" style="width:195px;"></el-input>
                    </el-form-item>

                    <el-form-item   prop="sex" label="性别">
                       <el-select v-model="form.sex" clearable placeholder="请选择">
                            <el-option
                                v-for="item in sexs"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item   prop="type" label="名单类型">
                       <el-select v-model="form.type" clearable placeholder="请选择">
                            <el-option
                                v-for="item in types"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="头像">
                        <el-upload 
                            class="avatar-uploader"
                            :action="uploadUrl"
                            :show-file-list="false"
                            :auto-upload="true"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="imageUrl" :src="imageUrl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                visible: false,
                loading:false,
                isAuto:false,
                headers: {
                    Authorization: 'Bearer '+ sessionStorage.getItem('token')
                },
                form:{
                    deptId:"",
                    name:"",
                    identityCard:"",
                    sex:"",
                    type:"",
                    faceImage:""
                },
                uploadForm:new FormData(),
                imageUrl: "",
                uploadUrl:"",
                rules: {
                    name: [
                        { required: true, message: '请输入姓名', trigger: 'blur' }
                    ],
                    identityCard: [
                        { required: true, message: '请输入身份证', trigger: 'blur' }
                    ],
                    sex: [
                        { required: true, message: '请选择性别', trigger: 'blur' }
                    ],
                    type: [
                        { required: true, message: '请选择名单类型', trigger: 'blur' }
                    ]
                },
                sexs:[{
                    value: 1,
                    label: '男'
                }, {
                    value: 2,
                    label: '女'
                }],
                types:[{
                    value: '01',
                    label: '犯罪嫌疑人'
                },{
                    value: '02',
                    label: '重点关注人员'
                },{
                    value: '03',
                    label: 'VIP访客'
                }]
            }
        },
        created:function () {
        },
        methods:{
            init(deptId){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.uploadForm=new FormData(); 
                this.uploadUrl=this.nameUploadImageUrl;
                this.form.deptId=deptId;
                this.imageUrl="";
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            handleAvatarSuccess(res, file) {
                this.imageUrl = URL.createObjectURL(file.raw);
            },
            beforeAvatarUpload(file) {
                 let isJPG = (file.type == 'image/jpeg' || file.type == 'image/png');
                let isLt2M = file.size / 1024 / 1024 < 8;

                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 8MB!');
                }
                if(isJPG && isLt2M){
                    // 上传文件
                    // this.uploadForm.append('file', file);
                    let uploadForm=new FormData();
                    uploadForm.append('file', file);
                    this.$axios.post(this.nameUploadImageUrl, uploadForm).then((res) => {
                        if(res.data.status == 200){
                        //    console.log("临时文件目录："+res.data.data.localFile);
                           this.form.faceImage=res.data.data.localFile;
                        }else{
                            this.$commonFn.showTip(res.data.message, 3);
                        }
                    }, (err) => {
                        console.log(err)
                        this.$commonFn.showTip("网络繁忙，请稍后重试，响应码("+err.response.status+")", 3);
                    });
                }else{
                    return false;
                }
            },
            save(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        this.loading=true;
                        let url = this.nameSaveUrl;
                        let data = {
                            deptId:this.form.deptId,
                            name:this.form.name,
                            identityCard:this.form.identityCard,
                            sex:this.form.sex,
                            type:this.form.type,
                            faceImage:this.form.faceImage
                        }; 
                        // console.log("提交列表:"+JSON.stringify(data))
                        this.apiPost(url, data).then((res) => {
                            // console.log("响应列表:"+JSON.stringify(res))
                            if(res.status == 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message, 3,true);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(JSON.stringify(err));
                            this.$commonFn.showTip(err.message, 3);
                            this.loading=false;
                        });
                    }
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }

    .avatar {
        width: 130px;
        height: 108px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/set/name/Add.vue